var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"15px","margin-bottom":"60px"}},[_c('div',[_vm._v(" "+_vm._s(_vm.$t('operate'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }